import axios from "axios";
import {
  getLocalStorageToken,
  removeLocalStorageToken,
} from "../utils/common.util";
import appNotificaton from "../utils/notification";
import config from "../config";
import logger from "../utils/logger";
import store from "../redux/store";
import { logout } from "../redux/AuthSlice/index.slice";

export const ServiceRequest = async ({
  // authToken = "",
  method,
  formHeaders,
  baseURL,
  url,
  queryParams,
  bodyData,
  cancelFunction,
  removeHeaders,
  cancelRequest,
}) => {
  try {
    const apiToken = getLocalStorageToken();
    const axiosConfig = {
      method: method || "GET",
      baseURL: config.API_BASE_URL,
      headers: {
        "content-type": "application/json",
      },
    };
    if (formHeaders) {
      axiosConfig.headers = { ...axiosConfig.headers, ...formHeaders };
    }

    if (baseURL) {
      axiosConfig.baseURL = baseURL;
    }

    if (url) {
      axiosConfig.url = url;
    }

    if (queryParams) {
      const queryParamsPayload = {};
      for (const key in queryParams) {
        if (Object.hasOwnProperty.call(queryParams, key)) {
          let element = queryParams[key];
          if (typeof element === "string") {
            element = element.trim();
          }
          if (!["", null, undefined, NaN].includes(element)) {
            queryParamsPayload[key] = element;
          }
        }
      }
      axiosConfig.params = queryParamsPayload;
    }

    if (bodyData) {
      const bodyPayload = {};
      for (const key in bodyData) {
        if (Object.hasOwnProperty.call(bodyData, key)) {
          let element = bodyData[key];
          if (typeof element === "string") {
            element = element.trim();
          }
          if (![null, undefined, NaN].includes(element)) {
            bodyPayload[key] = element;
          }
        }
      }
      axiosConfig.data = bodyPayload;
    }

    if (cancelFunction) {
      axiosConfig.cancelToken = new axios.CancelToken((cancel) => {
        cancelFunction(cancel);
      });
    }

    if (cancelRequest) {
      axiosConfig.signal = cancelRequest.signal;
    }

    if (removeHeaders) {
      delete axiosConfig.headers;
    }

    if (apiToken) {
      axiosConfig.headers = {
        ...axiosConfig.headers,
        authorization: `Bearer ${apiToken}`,
      };
    }

    const res = await axios(axiosConfig);
    return res.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      logger(error?.message);

      // appNotificaton({
      //   type: "error",
      //   message: error?.message,
      // });
    } else {
      appNotificaton({
        type: "error",
        message:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message,
      });
    }

    if ([401].includes(error?.response?.status)) {
      removeLocalStorageToken();
      store.dispatch(logout());
      let path = "/";
      window.location.replace(path);
    }
    throw new Error(error);
  }
};
